/**
* Created by ctsi-biyi-generator
*/
export default {
'zh-CN': {
'tqtFeedback.id.label': '',
'tqtFeedback.id.holder': '请输入',
'tqtFeedback.id.max': '最多11个字符',
'tqtFeedback.id.required': '必填',
'tqtFeedback.searchId.holder': '搜索',
'tqtFeedback.name.label': '姓名',
'tqtFeedback.name.holder': '请输入姓名',
'tqtFeedback.name.max': '姓名最多11个字符',
'tqtFeedback.name.required': '姓名必填',
'tqtFeedback.searchName.holder': '搜索姓名',
'tqtFeedback.phone.label': '手机号',
'tqtFeedback.phone.holder': '请输入手机号',
'tqtFeedback.phone.max': '手机号最多11个字符',
'tqtFeedback.phone.required': '手机号必填',
'tqtFeedback.searchPhone.holder': '搜索手机号',
'tqtFeedback.content.label': '反馈内容',
'tqtFeedback.content.holder': '请输入反馈内容',
'tqtFeedback.content.max': '反馈内容最多1,028个字符',
'tqtFeedback.content.required': '反馈内容必填',
'tqtFeedback.searchContent.holder': '搜索反馈内容',
'tqtFeedback.userId.label': '用户id',
'tqtFeedback.userId.holder': '请输入用户id',
'tqtFeedback.userId.max': '用户id最多11个字符',
'tqtFeedback.userId.required': '用户id必填',
'tqtFeedback.searchUserId.holder': '搜索用户id',
'tqtFeedback.status.label': '0未处理，1处理',
'tqtFeedback.status.holder': '请输入0未处理，1处理',
'tqtFeedback.status.max': '0未处理，1处理最多1个字符',
'tqtFeedback.status.required': '0未处理，1处理必填',
'tqtFeedback.searchStatus.holder': '搜索0未处理，1处理',
'tqtFeedback.createTime.label': '',
'tqtFeedback.createTime.holder': '请输入',
'tqtFeedback.createTime.max': '最多null个字符',
'tqtFeedback.createTime.required': '必填',
'tqtFeedback.searchCreateTime.holder': '搜索',
'tqtFeedback.solveTime.label': '解决时间',
'tqtFeedback.solveTime.holder': '请输入解决时间',
'tqtFeedback.solveTime.max': '解决时间最多null个字符',
'tqtFeedback.solveTime.required': '解决时间必填',
'tqtFeedback.searchSolveTime.holder': '搜索解决时间',
'tqtFeedback.solveContent.label': '解决内容',
'tqtFeedback.solveContent.holder': '请输入解决内容',
'tqtFeedback.solveContent.max': '解决内容最多500个字符',
'tqtFeedback.solveContent.required': '解决内容必填',
'tqtFeedback.searchSolveContent.holder': '搜索解决内容',
},
'zh-TW': {
'tqtFeedback.id.label': '',
'tqtFeedback.id.holder': '請輸入',
'tqtFeedback.id.max': '最多11個字符',
'tqtFeedback.id.required': '必填',
'tqtFeedback.searchId.holder': '搜索',
'tqtFeedback.name.label': '姓名',
'tqtFeedback.name.holder': '請輸入姓名',
'tqtFeedback.name.max': '姓名最多11個字符',
'tqtFeedback.name.required': '姓名必填',
'tqtFeedback.searchName.holder': '搜索姓名',
'tqtFeedback.phone.label': '手机号',
'tqtFeedback.phone.holder': '請輸入手机号',
'tqtFeedback.phone.max': '手机号最多11個字符',
'tqtFeedback.phone.required': '手机号必填',
'tqtFeedback.searchPhone.holder': '搜索手机号',
'tqtFeedback.content.label': '反馈内容',
'tqtFeedback.content.holder': '請輸入反馈内容',
'tqtFeedback.content.max': '反馈内容最多1,028個字符',
'tqtFeedback.content.required': '反馈内容必填',
'tqtFeedback.searchContent.holder': '搜索反馈内容',
'tqtFeedback.userId.label': '用户id',
'tqtFeedback.userId.holder': '請輸入用户id',
'tqtFeedback.userId.max': '用户id最多11個字符',
'tqtFeedback.userId.required': '用户id必填',
'tqtFeedback.searchUserId.holder': '搜索用户id',
'tqtFeedback.status.label': '0未处理，1处理',
'tqtFeedback.status.holder': '請輸入0未处理，1处理',
'tqtFeedback.status.max': '0未处理，1处理最多1個字符',
'tqtFeedback.status.required': '0未处理，1处理必填',
'tqtFeedback.searchStatus.holder': '搜索0未处理，1处理',
'tqtFeedback.createTime.label': '',
'tqtFeedback.createTime.holder': '請輸入',
'tqtFeedback.createTime.max': '最多null個字符',
'tqtFeedback.createTime.required': '必填',
'tqtFeedback.searchCreateTime.holder': '搜索',
'tqtFeedback.solveTime.label': '解决时间',
'tqtFeedback.solveTime.holder': '請輸入解决时间',
'tqtFeedback.solveTime.max': '解决时间最多null個字符',
'tqtFeedback.solveTime.required': '解决时间必填',
'tqtFeedback.searchSolveTime.holder': '搜索解决时间',
'tqtFeedback.solveContent.label': '解决内容',
'tqtFeedback.solveContent.holder': '請輸入解决内容',
'tqtFeedback.solveContent.max': '解决内容最多500個字符',
'tqtFeedback.solveContent.required': '解决内容必填',
'tqtFeedback.searchSolveContent.holder': '搜索解决内容',
},
'en-US': {
'tqtFeedback.id.label': '',
'tqtFeedback.id.holder': 'Enter ',
'tqtFeedback.id.max': ' max length: 11',
'tqtFeedback.id.required': ' required',
'tqtFeedback.searchId.holder': 'Search ',
'tqtFeedback.name.label': '姓名',
'tqtFeedback.name.holder': 'Enter 姓名',
'tqtFeedback.name.max': '姓名 max length: 11',
'tqtFeedback.name.required': '姓名 required',
'tqtFeedback.searchName.holder': 'Search 姓名',
'tqtFeedback.phone.label': '手机号',
'tqtFeedback.phone.holder': 'Enter 手机号',
'tqtFeedback.phone.max': '手机号 max length: 11',
'tqtFeedback.phone.required': '手机号 required',
'tqtFeedback.searchPhone.holder': 'Search 手机号',
'tqtFeedback.content.label': '反馈内容',
'tqtFeedback.content.holder': 'Enter 反馈内容',
'tqtFeedback.content.max': '反馈内容 max length: 1,028',
'tqtFeedback.content.required': '反馈内容 required',
'tqtFeedback.searchContent.holder': 'Search 反馈内容',
'tqtFeedback.userId.label': '用户id',
'tqtFeedback.userId.holder': 'Enter 用户id',
'tqtFeedback.userId.max': '用户id max length: 11',
'tqtFeedback.userId.required': '用户id required',
'tqtFeedback.searchUserId.holder': 'Search 用户id',
'tqtFeedback.status.label': '0未处理，1处理',
'tqtFeedback.status.holder': 'Enter 0未处理，1处理',
'tqtFeedback.status.max': '0未处理，1处理 max length: 1',
'tqtFeedback.status.required': '0未处理，1处理 required',
'tqtFeedback.searchStatus.holder': 'Search 0未处理，1处理',
'tqtFeedback.createTime.label': '',
'tqtFeedback.createTime.holder': 'Enter ',
'tqtFeedback.createTime.max': ' max length: null',
'tqtFeedback.createTime.required': ' required',
'tqtFeedback.searchCreateTime.holder': 'Search ',
'tqtFeedback.solveTime.label': '解决时间',
'tqtFeedback.solveTime.holder': 'Enter 解决时间',
'tqtFeedback.solveTime.max': '解决时间 max length: null',
'tqtFeedback.solveTime.required': '解决时间 required',
'tqtFeedback.searchSolveTime.holder': 'Search 解决时间',
'tqtFeedback.solveContent.label': '解决内容',
'tqtFeedback.solveContent.holder': 'Enter 解决内容',
'tqtFeedback.solveContent.max': '解决内容 max length: 500',
'tqtFeedback.solveContent.required': '解决内容 required',
'tqtFeedback.searchSolveContent.holder': 'Search 解决内容',
}
};